// material
import { Box, BoxProps } from '@mui/material';
import { useTheme } from '@mui/system';
import { useGoogleTagManager } from '../hooks/useGoogleTagManager';

// ----------------------------------------------------------------------

interface LogoProps extends BoxProps {
  isOffset?: boolean;
}

export default function LogoLinkedIn({ sx, isOffset = true }: LogoProps) {
  const { palette } = useTheme();
  const { event } = useGoogleTagManager();

  const mediaInteraction = (media: string) => {
    event({
      path: media,
      event: 'Contact'
    });
  };
  return (
    <Box
      sx={{
        width: {
          xl: 42,
          lg: 42,
          md: 42,
          sm: 30,
          xs: 30
        },
        height: {
          xl: 42,
          lg: 42,
          md: 42,
          sm: 30,
          xs: 30
        },
        ...sx
      }}
    >
      <a
        target={'_blank'}
        onClick={() => mediaInteraction('LinkedIn')}
        href="https://www.linkedin.com/company/ibanonline_latinoam%C3%A9rica"
        rel="noreferrer"
        aria-label="Icon open linkedin"
      >
        <svg fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_724_10205)">
            <path
              d="M21 41.9985C32.598 41.9985 42 32.5965 42 20.9985C42 9.40056 32.598 -0.00146484 21 -0.00146484C9.40202 -0.00146484 0 9.40056 0 20.9985C0 32.5965 9.40202 41.9985 21 41.9985Z"
              fill={palette.primary.main}
            />
            <path
              d="M33.547 22.6894V31.3472H28.5274V23.2696C28.5274 21.2414 27.8026 19.8564 25.9852 19.8564C24.5982 19.8564 23.7743 20.7889 23.4104 21.6918C23.2783 22.0145 23.2442 22.4626 23.2442 22.9151V31.3469H18.2243C18.2243 31.3469 18.2917 17.6661 18.2243 16.2499H23.2446V18.3893C23.2345 18.4061 23.2203 18.4226 23.2113 18.4387H23.2446V18.3893C23.9117 17.3628 25.1014 15.8954 27.7686 15.8954C31.071 15.8954 33.547 18.0531 33.547 22.6894ZM12.973 8.97266C11.2558 8.97266 10.1324 10.0998 10.1324 11.5807C10.1324 13.0302 11.2233 14.1899 12.9071 14.1899H12.9396C14.6905 14.1899 15.779 13.0302 15.779 11.5807C15.7457 10.0998 14.6905 8.97266 12.973 8.97266ZM10.4308 31.3472H15.4489V16.2499H10.4308V31.3472Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_724_10205">
              <rect width="42" height="42" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </a>
    </Box>
  );
}
